module.exports = __webpack_public_path__ + "static/img/bottomBg_moon.bb69039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottomBg_moon.png
// module id = D5WT
// module chunks = 0